import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmationPopup from '../component/ConfirmationPopup';
import Spinner from "../component/Spinner";
import axiosInstance from "../networking/axiosconfig";
import { IoIosAdd } from "react-icons/io";
import LeaveTypepopup from "../component/LeaveTypepopup";
import Navbar from './Navbar';
import { CalendarDays, Plus } from 'lucide-react';
import Pagination from '../component/Pagination';

const LeaveTypeList = () => {
    const [leaveTypeList, setLeaveTypeList] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [showLeavepopup, setShowLeavepopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const leaveTypeUrl = `/api/leave/leave/type`;
    const [searchTerm, setSearchTerm] = useState("");
    const [popupKey, setPopupKey] = useState(0);

    //  Fetch Department List
    useEffect(() => {
        axiosInstance.get(leaveTypeUrl)
            .then((res) => {
                if (res.data && Array.isArray(res.data.data)) {
                    setLeaveTypeList(res.data.data);
                    setFilteredEmployees(res.data.data);
                } else {
                    console.error('Invalid data format');
                }
            })
            .catch((error) => console.error('Error fetching data:', error))
            .finally(() => setLoading(false));
    }, []);

    const handleDeleteClick = (leave_type_id_PK) => {
        setSelectedId(leave_type_id_PK);
        setPopupVisible(true);
    };

    //  Handle Confirm Delete
    const handleConfirmDelete = async () => {
        if (!selectedId) return;

        try {
            await axiosInstance.delete(`${leaveTypeUrl}/${selectedId}`);
            console.log("this Leave type deleted successfully");

            setLeaveTypeList(prev => prev.filter(item => item.leave_type_id_PK !== selectedId));
            setPopupVisible(false);
        } catch (error) {
            console.error("Error deleting leave type:", error);
        }
    };

    useEffect(() => {
        const filtered = leaveTypeList.filter(element =>
            element.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchTerm, leaveTypeList]);
    //  Pagination Logic
    const totalItems = filteredEmployees.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentLeaveTypeList = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);

    // handle Add buton
    const handleButtonClick = () => {
        setSelectedId(null);
        setPopupKey(prev => prev + 1);
        setShowLeavepopup(true);
    }


    const handleEditClick = (leave_type_id_PK) => {
        setShowLeavepopup(false);

        setTimeout(() => {
            setSelectedId(leave_type_id_PK);
            setPopupKey(prev => prev + 1);  // ⭐
            setShowLeavepopup(true);
        }, 0);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            <Navbar />
            <ConfirmationPopup
                open={isPopupVisible}
                setOpen={setPopupVisible}
                title="Delete"
                message="Are you sure you want to delete this Leave type?"
                confirmText="Delete"
                onConfirm={handleConfirmDelete}
            />

            {showLeavepopup && (
                <LeaveTypepopup
                    key={popupKey}
                    selectedId={selectedId}
                    onClose={() => {
                        setShowLeavepopup(false);
                        setSelectedId(null);
                    }}
                />
            )}


            <div className="max-w-7xl mx-auto p-6">


                <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg">
                                <CalendarDays size={32} />
                            </div>
                            <div>
                                <h1 className="text-3xl md:text-4xl font-bold mb-2">Leave Type List</h1>
                                <h2 className="text-xs md:text-sm ml-1 font-inter ">Welcome to the Leave Type List.</h2>
                            </div>
                        </div>
                        <button
                            onClick={handleButtonClick}
                            className="flex items-center gap-2 px-6 py-3 bg-white text-blue-600 rounded-lg hover:bg-blue-50 transition-colors font-semibold shadow-lg"
                        >
                            <Plus size={20} />
                            <span> Add Leave Type
                            </span>
                        </button>

                    </div>
                </div>

                <div className="w-full  h-full ">
                    <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden lg:mt-8 mt-6 ml-1">
                        <thead className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                            <tr>
                                <th className="py-3 px-4 text-sm font-inter text-left font-semibold text-white">S.No.</th>
                                <th className="py-3 px-4 text-sm font-inter text-left font-semibold text-white">Name</th>
                                <th className="py-3 px-4 text-sm font-inter font-semibold text-white">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {loading ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-12">
                                        <Spinner size={30} color="#3498db" loading={loading} />
                                    </td>
                                </tr>
                            ) : currentLeaveTypeList.length > 0 ? (
                                currentLeaveTypeList.map((element, index) => (
                                    <tr key={element.leave_type_id_PK} className="border-b hover:bg-gray-50 text-center">
                                        <td className="px-4 py-4 text-left text-sm font-inter">{index + 1}</td>
                                        <td className="px-4 py-4 text-left text-sm font-inter">{element.name}</td>
                                        <td className="px-4 py-4 text-sm font-inter">
                                            <button
                                                onClick={() => handleEditClick(element.leave_type_id_PK)}

                                                className="text-blue-600 mr-3 hover:text-text-900 font-inter"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDeleteClick(element.leave_type_id_PK)}
                                                className="text-red-600 hover:text-red-900 font-inter"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-6 text-gray-500 font-inter">No departments found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="max-w-7xl mx-auto">
                <div className="w-full bg-white rounded-2xl ">
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                    />
                </div>
            </div>
        </div>
    );
};

export default LeaveTypeList;